import styled from "styled-components";
import { ToggleLocalMicButton } from "./ToggleLocalMicButton";
import { ToggleSettingsModalButton } from "./ToggleSettingsModalButton";
import { HelpButton } from "./HelpButton";
import { FeedbackButton } from "./FeedbackButton";

export const ActionBar = ({
  reportLocation
}) => {
  return (
    <Container>
      <ToggleLocalMicButton />
      <ToggleSettingsModalButton />
      <HelpButton />
      <FeedbackButton reportLocation={reportLocation} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px 8px;
  border-radius: 28px;
`;
